import { OtsActionButton } from "../components/OtsButton";
import { OtsCheckbox } from "../components/OtsCheckbox";
import type { ActivityRateModelOption } from "./driver-activity-view-model";

export type ActivityRateModelChoicesProps = {
  /** Every rate model on offer: the region's and any on the day's tickets. */
  options: ActivityRateModelOption[];
  /** The rate models counted now: the picks, else the hauling ones. */
  counted: string[];
  /** What was picked; missing until something is, when the hauling rate models count. */
  value?: string[];
  onChange: (value: string[] | undefined) => void;
  /** Class for the section heading, to match the panel around it. */
  headingClassName?: string;
};

/**
 * Which rate models the day's revenue and cost come from, and which a shift is costed with: WaterGo's rate model
 * filter, in the display options. It starts on the hauling rate models; Hauling goes back to them.
 */
export const ActivityRateModelChoices = ({ options, counted, value, onChange, headingClassName }: ActivityRateModelChoicesProps) => (
  <fieldset className="!m-0 flex min-w-0 flex-col gap-1.5 !border-0 !p-0">
    <legend className={headingClassName}>Revenue and cost from</legend>
    {options.map(({ name }) => (
      <OtsCheckbox
        key={name}
        size="compact"
        label={name}
        checked={counted.includes(name)}
        onChange={(event) => onChange(event.target.checked ? [...counted, name] : counted.filter((other) => other !== name))}/>
    ))}
    <div className="flex justify-end gap-1">
      <OtsActionButton size="compact" variant="text" disabled={value === undefined} onClick={() => onChange(undefined)}>Hauling</OtsActionButton>
      <OtsActionButton size="compact" variant="text" disabled={options.every(({ name }) => counted.includes(name))} onClick={() => onChange(options.map(({ name }) => name))}>All</OtsActionButton>
    </div>
  </fieldset>
);
